import { v4 as uuidv4 } from 'uuid';
import { RootState } from './index';

import { Filter } from '../Enum/Filters';
import { Account, ClientType } from '../Enum/Filters/';

import { initialDecoratorValues } from './Filter/reducer';

/**
 * Migration 0: FIN-810: Added NewsLabels to the filter
 * Migration 1: AVB-116: Convert Fixed Periods from string to number
 * Migration 2: AVB-136: Added userId to app state
 * Migration 3: VWV-53/-54: Add initial print state and added filter for new customer buckets only
 * Migration 4: VWV-69: Add toggled property categories array to the filter state
 * Migration 5: VWV-115: Convert Fixed Periods from number to Period and Fixed Period back to string
 * Migration 6: VWV-137: Added Bridging Loan Page
 * Migration 7: VWV-103: Made it possible to select up to 8 labels / properties and select up to 3 for downloading
 * Migration 8: VWV-139: Added Account filter
 * Migration 9: VWV-147: Support for collapsable scopes
 */
export const migrations = {
    0: (state: RootState) => ({
        ...state,
        filter: {
            ...state.filter,
            filterValues: {
                ...state.filter.filterValues,
                [Filter.NewsLabels]: [],
            },
            filteredValues: {
                ...state.filter.filteredValues,
                [Filter.NewsLabels]: [],
            },
        },
    }),
    1: (state: RootState) => ({
        ...state,
        filter: {
            ...state.filter,
            filterValues: {
                ...state.filter.filterValues,
                [Filter.FixedPeriod]: parseInt(state.filter.filterValues[Filter.FixedPeriod].toString()),
                [Filter.FixedPeriods]: state.filter.filterValues[Filter.FixedPeriods].map(fixedPeriod =>
                    parseInt(fixedPeriod.toString()),
                ),
            },
            filteredValues: {
                ...state.filter.filteredValues,
                [Filter.FixedPeriod]: parseInt(state.filter.filteredValues[Filter.FixedPeriod].toString()),
                [Filter.FixedPeriods]: state.filter.filteredValues[Filter.FixedPeriods].map(fixedPeriod =>
                    parseInt(fixedPeriod.toString()),
                ),
            },
        },
    }),
    2: (state: RootState) => ({
        ...state,
        app: {
            ...state.app,
            userId: uuidv4(),
        },
    }),
    3: (state: RootState) => ({
        ...state,
        pdf: false,
        filter: {
            ...state.filter,
            filterValues: {
                ...state.filter.filterValues,
                [Filter.ClientType]: ClientType.NEW,
            },
            filteredValues: {
                ...state.filter.filteredValues,
                [Filter.ClientType]: ClientType.NEW,
            },
        },
    }),
    4: (state: RootState) => ({
        ...state,
        filter: {
            ...state.filter,
            toggledPropertyCategories: [],
        },
    }),
    5: (state: RootState) => ({
        ...state,
        filter: {
            ...state.filter,
            filterValues: {
                ...state.filter.filterValues,
                [Filter.FixedPeriod]: state.filter.filterValues[Filter.FixedPeriod].toString(),
                [Filter.FixedPeriods]: state.filter.filterValues[Filter.FixedPeriods].map(period => ({ period })),
            },
            filteredValues: {
                ...state.filter.filteredValues,
                [Filter.FixedPeriod]: state.filter.filteredValues[Filter.FixedPeriod].toString(),
                [Filter.FixedPeriods]: state.filter.filteredValues[Filter.FixedPeriods].map(period => ({ period })),
            },
        },
    }),
    6: (state: RootState) => ({
        ...state,
        filter: {
            ...state.filter,
            filterValues: {
                ...state.filter.filterValues,
                [Filter.BridgingLoanLabels]: [],
            },
            filteredValues: {
                ...state.filter.filteredValues,
                [Filter.BridgingLoanLabels]: [],
            },
            decoratorValues: initialDecoratorValues,
        },
    }),
    7: (state: RootState) => ({
        ...state,
        pdf: {
            ...state.pdf,
            filterValues: [],
            filterValuesSelected: [],
        },
        modal: {
            ...state.modal,
            className: undefined,
        },
        properties: {
            properties: [],
        },
    }),
    8: (state: RootState) => ({
        ...state,
        filter: {
            ...state.filter,
            filterValues: {
                ...state.filter.filterValues,
                [Filter.Account]: Account.Ja,
            },
            filteredValues: {
                ...state.filter.filteredValues,
                [Filter.Account]: Account.Ja,
            },
        },
    }),
    9: (state: RootState) => ({
        ...state,
        scopes: {
            scopes: [],
        },
    }),
};
